<template>
  <div class="main-wrapper" v-if="serviceCodes">
    <el-tabs v-model="serviceCodeType" v-on:tab-click="btnNavClick">
      <el-tab-pane label="待发送服务码" name="Apply"></el-tab-pane>
      <el-tab-pane label="已发送服务码" name="SendOut"></el-tab-pane>
    </el-tabs>

    <el-table :data="serviceCodes" width="100%">
      <el-table-column v-if="serviceCodeType === 'SendOut'" label="ICP 备案服务码">
        <template #default="scope">
          {{ scope.row.code }}
        </template>
      </el-table-column>
      <el-table-column label="网站云">
        <template #default="scope">
          <template v-if="scope.row.host">
            <el-link
              type="primary"
              style="margin-right: 5px"
              :underline="false"
              :href="getUrl(scope.row.host)"
              target="_blank"
            >
              {{ getUniqueName(scope.row.host) }}
            </el-link>
            <br v-if="scope.row.host.nickName" />
            <el-link :underline="false" @click.prevent>
              {{ scope.row.host.nickName }}
            </el-link>
          </template>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template #default="scope">
          {{ scope.row.isFree ? '免费' : '收费' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template #default="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
      <el-table-column v-if="serviceCodeType === 'SendOut'" align="center" label="发送时间">
        <template #default="scope">
          {{ scope.row.sendOutDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <div class="actions">
            <el-link type="primary" v-if="serviceCodeType === 'Apply'" :underline="false" @click.prevent="btnSendOutClick(scope.row)">发 送</el-link>
            <el-link type="danger" :underline="false" @click.prevent="btnDeleteClick(scope.row)">删 除</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="发送服务码" v-model="isSendOutForm" width="40%">
      <el-form style="margin: 0 10px" ref="sendOutForm" :model="sendOutForm" label-position="left" label-width="120px">
        <el-form-item label="服务码" prop="code" :rules="{ required: true, message: '请输入服务码' }">
          <el-input v-model="sendOutForm.code" placeholder="请输入服务码"></el-input>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnSendOutSubmitClick">确 定</el-button>
          <el-button @click="isSendOutForm = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IHost, IServiceCode } from '@/types/models';
import api from '@/api/admin/serviceCodes';
import utils from '@/utils';
import { IElForm } from '@/types/element';

interface IUpdateImageForm {
  id: number;
  code: string;
}

interface IState {
  serviceCodeType: string;
  serviceCodes: IServiceCode[];
  isSendOutForm: boolean;
  sendOutForm: IUpdateImageForm;
}

export default defineComponent({
  data() {
    return {
      serviceCodeType: 'Apply',
      serviceCodes: [],
      isSendOutForm: false,
      sendOutForm: {} as IUpdateImageForm,
    } as IState;
  },
  methods: {
    apiGet() {
      const isSendOut = this.serviceCodeType === 'SendOut';
      api.get({ isSendOut }, (res) => {
        this.serviceCodes = res.serviceCodes;
      });
    },

    getUrl(host: IHost): string {
      return utils.getHostUrl(host.hostName, host.nodeName, host.isHongKong);
    },

    getUniqueName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    btnNavClick() {
      this.apiGet();
    },

    btnSendOutClick(serviceCode: IServiceCode) {
      this.sendOutForm.id = serviceCode.id;
      this.sendOutForm.code = '';
      this.isSendOutForm = true;
    },

    btnSendOutSubmitClick() {
      (this.$refs.sendOutForm as IElForm).validate((valid) => {
        if (valid) {
          api.submit(this.sendOutForm, (res) => {
            if (!res) return;
            this.isSendOutForm = false;
            this.apiGet();
            utils.success('服务码发送成功');
          });
        }
      });
    },

    btnDeleteClick(serviceCode: IServiceCode) {
      utils.alertDelete(
        {
          title: '删除服务码',
          text: `此操作将删除服务码 ${serviceCode.code || serviceCode.id}，确定吗？`,
          button: '确认删除',
        },
        () => {
          api.delete(serviceCode.id, (res) => {
            if (!res) return;
            this.apiGet();
            utils.success('服务码删除成功');
          });
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
